/**
 * streamRender — append a message into a chat stream, inserting a
 * day-divider whenever the message's localtime day differs from the
 * previously-appended message's day.
 *
 * Kept in lib/ so ChatView stays focused on wiring. The caller passes
 * its own `buildMessage` so this module has no React/DOM coupling
 * beyond a plain HTMLElement-builder callback.
 */

import { buildDayDivider, dayKey } from "./dateGroup";

const LAST_DAY_ATTR = "data-last-day";

/**
 * appendWithDivider — append a message bubble, prepending a divider
 * row if the new day differs from `stream`'s last-recorded day. Stores
 * the current day on the stream element for the next call.
 */
export function appendWithDivider(
  stream: HTMLElement,
  tsSec: string | number,
  bubble: HTMLElement,
): void {
  const k = dayKey(tsSec);
  const prev = stream.getAttribute(LAST_DAY_ATTR);
  if (k && k !== prev) {
    stream.appendChild(buildDayDivider(tsSec));
    stream.setAttribute(LAST_DAY_ATTR, k);
  }
  stream.appendChild(bubble);
}

/** Reset day-tracking — call before the initial render of a new chat. */
export function resetDividers(stream: HTMLElement): void {
  stream.removeAttribute(LAST_DAY_ATTR);
}
